import React from 'react';
import {observer} from 'mobx-react';
import {Checkbox, ObjectSelect2, Select2} from 'shared/components';
import {Table} from 'main/components';
import {FormattedMessage} from 'react-intl';
import {withState} from 'shared/core';
import ReviewsListState from 'main/containers/employees/hire/components/steps/reviews/reviews_list/ReviewsListState';
import _ from 'lodash';

const ReviewsCheckbox = observer(({model, uiState}) => {
  return (
    <Checkbox
      checked={model.selected}
      onChange={() => uiState.toggleCycle(model)}
    />
  );
});

const DueDate = observer(({model}) => {
  switch (model.data.relativeDueDateUnit) {
    case 'days':
      return (
        <FormattedMessage id='employees.hire.reviews.OFFSET_DATE_IN_DAYS' values={{
          number: model.data.relativeDueDateValue
        }}
        />
      );
    case 'weeks':
      return (
        <FormattedMessage id='employees.hire.reviews.OFFSET_DATE_IN_WEEKS' values={{
          number: model.data.relativeDueDateValue
        }}
        />
      );
    default:
      throw new Error(`Relative date unit ${model.data.relativeDueDateUnit} not supported.`);
  }
});

const LaunchDate = observer(({model}) => {
  switch (model.data.relativeLaunchDateUnit) {
    case 'days':
      return (
        <FormattedMessage id='employees.hire.reviews.OFFSET_DATE_IN_DAYS' values={{
          number: model.data.relativeLaunchDateValue
        }}
        />
      );
    case 'weeks':
      return (
        <FormattedMessage id='employees.hire.reviews.OFFSET_DATE_IN_WEEKS' values={{
          number: model.data.relativeLaunchDateValue
        }}
        />
      );
    default:
      throw new Error(`Relative date unit ${model.data.relativeLaunchDateUnit} not supported.`);
  }
});

const Managers = observer(({model, uiState}) => {
  const {availableManagers} = uiState;

  return (
    <ObjectSelect2
      items={availableManagers}
      value={model.data.reviewManagerEmployees}
      disabled={!model.selected}
      multiple
      searchable
      allowClear
      onAdd={employee => uiState.addManager(model.data, employee)}
      onRemove={employee => uiState.removeManager(model.data, employee)}
      placeholder='employees.hire.reviews.Select managers'
    />
  );
});

const COLUMNS = [
  {
    component: ReviewsCheckbox,
    width: 0.5
  },
  {
    header: 'employees.hire.reviews.Reviews',
    attribute: 'data.name',
    width: 2.5
  },
  {
    header: 'employees.hire.reviews.Managers',
    component: Managers,
    width: 5
  },
  {
    header: 'employees.hire.reviews.Launch Date',
    component: LaunchDate,
    width: 2
  },
  {
    header: 'employees.hire.reviews.Due Date',
    component: DueDate,
    width: 2
  },
];

const ReviewsList = observer(({uiState}) => {
  return (
    <Table
      showLinks={false}
      columns={COLUMNS}
      models={uiState.viewModels}
      uiState={uiState}
    />
  );
});

export default withState(ReviewsList, ReviewsListState);
